/**
 * @fileoverview GET handler for the "/engagement/campaigns/campaigns_with_carousel_slides" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsCampaignsWithCarouselSlides } from "./constants";
import type { EngagementCampaignsCampaignsWithCarouselSlidesResult } from "./types";

export const getEngagementCampaignsCampaignsWithCarouselSlides = reactQueryFetcherAdapter(
  engagementCampaignsCampaignsWithCarouselSlides,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number
  ): Promise<EngagementCampaignsCampaignsWithCarouselSlidesResult[]> => {
    return fetch(
      "/engagement/campaigns/campaigns_with_carousel_slides",
      "GET",
      { app_group_id: appGroupId, query, limit },
      { signal }
    );
  }
);
